import ErrorView from '../ErrorView';
import Loading from '../Loading';
import NoAccessMessageTikTok from './NoAccessMessageTikTok';
import { useFetchUserAbout } from '../../../utils/hooks/user';

function ErrorComponent() {
    return (
        <ErrorView>
            <h2>Oops! There may be an issue.</h2>
            <p>Your account profile information could not be loaded.</p>
            <p>Please try refreshing the page.</p>
        </ErrorView>
    );
}

/**
 * `header` renders above every branch that replaces `children` -- the upsell,
 * the spinner and the error. Callers whose chrome lives *inside* the children
 * (the data-source tabs, since they moved into the tab views) would otherwise
 * strand the user here with no way off the page.
 */
function IfHasTikTokAccess({
    children,
    header = null,
    NoAccessComponent = NoAccessMessageTikTok,
    LoadingComponent = Loading,
    ErrorComponent: ErrorComp = ErrorComponent,
}) {
    const userAboutQuery = useFetchUserAbout();
    const hasTikTokAccess = userAboutQuery.data?.hasTikTokAccess;
    if (hasTikTokAccess) return children;

    const instead = (node) => (
        <>
            {header}
            {node}
        </>
    );
    if (hasTikTokAccess === false) return instead(<NoAccessComponent />);
    if (userAboutQuery.isLoading) return instead(<LoadingComponent />);
    if (userAboutQuery.isError) return instead(<ErrorComp />);
}

export default IfHasTikTokAccess;
